import { Box, BoxProps } from '@material-ui/core';
import React from 'react';

interface FlexRowProps extends BoxProps {
  children: React.ReactNode | React.ReactNode[];
}

export const FlexRow = ({ children, ...props }: FlexRowProps) => {
  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      justifyContent={'space-between'}
      alignItems={'center'}
      gridGap={8}
      {...props}
    >
      {children}
    </Box>
  );
};
